import { EvtHeader } from "components/header";
import React from "react";
import HeaderPortal from "components/portal/header-portal";
import EditItemButton from "components/buttons/edit";
import { PermissionControlledInput } from "permissions/components/input";
import ProjectLayout from "@/modules/work/projects/layout";
import PeopleSection from "./components/people";
import IntegrationsSection from "./components/integrations";
import TagsSection from "./components/tags";
import { ProjectDashboardStatsSection } from "./components/stats";
import { useParams } from "react-router-dom";
import { Icon } from "components";
import { Button } from "ui/components/button";

// Outrel host; override per environment with VITE_OUTREL_URL (e.g. for QA).
const OUTREL_URL = import.meta.env.VITE_OUTREL_URL;
export default function ProjectDashboard() {
  return (
    <ProjectLayout>
      <ProjectDashboardContent />
    </ProjectLayout>
  );
}
function ProjectDashboardContent() {
  // project_slug in the route is the project's project_id, which Outrel uses in its URL.
  const { project_slug: projectSlug } = useParams();
  return (
    <>
      <div className="flex-1 overflow-auto">
        <EvtHeader title="Dashboard" />
        <TagsSection />
        <ProjectDashboardStatsSection />
        {/* <BudgetSection /> */}
        {/* <ProjectBillablesSection /> */}
        <PeopleSection />
        <IntegrationsSection />
        {/* <ProjectBurnChart /> */}
        {/* <TimesheetActivitySection /> */}
      </div>
      <HeaderPortal>
        <div className="flex items-center gap-2">
          {/* Project showcase on Outrel (separate platform), visible to every role. */}
          {projectSlug && (
            <Button asChild variant="outline">
              <a
                href={`${OUTREL_URL}/work/projects/${encodeURIComponent(projectSlug)}/showcase`}
                target="_blank"
                rel="noreferrer"
              >
                Showcase
                <Icon icon="lucide:external-link" className="size-4" />
              </a>
            </Button>
          )}
          <PermissionControlledInput rule="update:PC,SC,AM" collection="projects">
            <EditItemButton />
          </PermissionControlledInput>
        </div>
      </HeaderPortal>
    </>
  );
}
